import { render, staticRenderFns } from "./ShowShare.vue?vue&type=template&id=5636f290&scoped=true"
import script from "./ShowShare.vue?vue&type=script&lang=js"
export * from "./ShowShare.vue?vue&type=script&lang=js"
import style0 from "./ShowShare.vue?vue&type=style&index=0&id=5636f290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5636f290",
  null
  
)

export default component.exports